<template>
    <div class="section section_one">
        <div class="main_content">
            <div class="container">
                <div class="row">
                
                <div class="col-md-12 mx-auto d-block mb-md-0 mb-4 full-content"> 
                    <div class="custom_border mx-auto">
                        <p data-aos="fade-up">
                            {{this.corporate.RichText[0]}}
                            {{this.corporate.RichText[1]}}
                        </p>
                    </div>
                </div>
                
                <div class="col-md-12 mx-auto d-block mb-md-0 mb-4 full-content">
                    <div class="custom_border mx-auto">
                        <p data-aos="fade-up" v-html="this.corporate.RichText[2]">
                            <!-- {{this.corporate.RichText[2]}} -->
                        </p>
                    </div>
                </div>
                <div class="col-md-12 mx-auto d-block mb-md-0 mb-4 full-content">
                    <div class="custom_border mx-auto">
                        <h5 data-aos="fade-up" v-html="this.corporate.RichText[3]">
                            <!-- {{this.corporate.RichText[3]}} -->
                        </h5>
                    </div>
                </div>
                

                <!-- Icons section start -->
                <div class="col-md-6 mx-auto d-md-block d-none"></div>
                <div class="col-md-6 mx-auto d-block icons_section mb-md-0 mb-4">
                    <div class="icons">
                        <div class="icon"  data-aos="fade-up">
                            <img :src="require(`../../assets/images/corporate-sustainability/svg/${this.corporate.IconSection[0].image}`)" alt="" class="img-fluid">
                        </div>
                        <div class="title text-uppercase" data-aos="fade-up">{{this.corporate.IconSection[0].title}}</div>
                    </div>
                    <div class="custom_border mx-auto">
                        <p data-aos="fade-up">
                            {{this.corporate.IconSection[0].description}}
                        </p>
                    </div>
                </div>

                <div class="col-md-6 mx-auto d-block icons_section icon_left mb-md-0 mb-4">
                    <div class="icons">
                        <div class="icon"  data-aos="fade-up">
                            <img :src="require(`../../assets/images/corporate-sustainability/svg/${this.corporate.IconSection[1].image}`)" alt="" class="img-fluid">
                        </div>
                        <div class="title"  data-aos="fade-up">{{this.corporate.IconSection[1].title}}</div>
                    </div>
                    <div class="custom_border mx-auto">
                        <ul>
                            <li v-for="list in this.corporate.IconSection[1].description" :key="list" data-aos="fade-up">{{list}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6 mx-auto d-md-block d-none"></div>
                <div class="col-md-6 mx-auto d-md-block d-none"></div>
                <div class="col-md-12 mx-auto d-block mb-md-0 mb-40 full-content">
                        <div class="custom_border mx-auto">
                            <h5  data-aos="fade-up">
                                {{this.corporate.IconSection[2].richText}}
                            </h5>
                        </div>
                </div>
                <div class="col-md-6 mx-auto d-block icons_section icon_left mb-md-0 mb-4">
                    <div class="icons">
                        <div class="icon"  data-aos="fade-up">
                            <img :src="require(`../../assets/images/corporate-sustainability/svg/${this.corporate.IconSection[3].image}`)" alt="" class="img-fluid">
                        </div>
                        <div class="title"  data-aos="fade-up">{{this.corporate.IconSection[3].title}}</div>
                    </div>
                    <div class="custom_border mx-auto">
                        <p v-html="this.corporate.IconSection[3].description"  data-aos="fade-up"></p>
                    </div>
                </div>
                <div class="col-md-6 mx-auto d-md-block d-none"></div>
                <div class="col-md-6 mx-auto d-md-block d-none"></div>
                <div class="col-md-6 mx-auto d-block icons_section mb-md-0 mb-4">
                    <div class="icons">
                        <div class="icon"  data-aos="fade-up">
                            <img :src="require(`../../assets/images/corporate-sustainability/svg/${this.corporate.IconSection[4].image}`)" alt="" class="img-fluid">
                        </div>
                        <div class="title"  data-aos="fade-up">
                            {{this.corporate.IconSection[4].title}}
                        </div>
                    </div>
                    <div class="custom_border mx-auto">
                        <p  data-aos="fade-up">
                            {{this.corporate.IconSection[4].description}}
                        </p>
                    </div>
                </div>
                <div class="col-md-6 mx-auto d-block icons_section icon_left mb-md-0 mb-4">
                    <div class="icons">
                        <div class="icon"  data-aos="fade-up">
                            <img :src="require(`../../assets/images/corporate-sustainability/svg/${this.corporate.IconSection[5].image}`)" alt="" class="img-fluid">
                        </div>
                        <div class="title"  data-aos="fade-up">
                            {{this.corporate.IconSection[5].title}}
                        </div>
                    </div>
                    <div class="custom_border mx-auto">
                        <p  data-aos="fade-up">
                            {{this.corporate.IconSection[5].description}}
                        </p>
                    </div>
                </div>
                <div class="col-md-6 mx-auto d-md-block d-none"></div>
                <div class="col-md-6 mx-auto d-md-block d-none"></div>
                <div class="col-md-6 mx-auto d-block icons_section mb-md-0 mb-4">
                    <div class="icons">
                        <div class="icon"  data-aos="fade-up">
                            <img :src="require(`../../assets/images/corporate-sustainability/svg/${this.corporate.IconSection[6].image}`)" alt="" class="img-fluid">
                        </div>
                        <div class="title"  data-aos="fade-up">
                            {{this.corporate.IconSection[6].title}}
                        </div>
                    </div>
                    <div class="custom_border mx-auto">
                        <p  data-aos="fade-up">
                            {{this.corporate.IconSection[6].description}}
                        </p>
                    </div>
                </div>
                <!-- <div class="col-md-12 mx-auto d-block icons_section icon_left images_section fullWidth mt-50 mb-md-0 mb-4">
                    <div class="row">
                        <div class="col-6">
                            >
                        </div>
                    </div>
                    <div class="custom_border mx-auto">
                        
                    </div>
                </div> -->
                <!-- <div class="col-md-12 mx-auto d-md-block d-none"></div> -->
                </div>
                <div class="row">
                     <div class="col-lg-12 brand-logos">
                        <div class="icons">
                            <p class="pt-0"  data-aos="fade-up">
                                    {{this.corporate.brandLogos.description}}
                                </p>
                            
                        </div>
                        <div class="custom_border mx-auto">
                            <div class="row">
                                <div class="col-md-3 col-6" v-for="image in this.corporate.brandLogos.logos" :key="image" data-aos="fade-up">
                                
                                    <div class="small_image">
                                        <img :src="require(`../../assets/images/corporate-sustainability/${image}`)" alt="" class="img-fluid">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 full-row mx-auto d-block icons_section icon_left images_section mt-50 mb-md-0 mb-4">
                        <div class="icons">
                            <p class="pt-0"  data-aos="fade-up">
                            {{this.corporate.smallImagesection.description}} 
                            </p>
                        </div>
                        <div class="custom_border mx-auto">
                            <div class="row pt-40 align-items-center">
                                <div  data-aos="fade-up" class="col-8" >
                                    <div class="">
                                        <img :src="require(`../../assets/images/corporate-sustainability/${this.corporate.smallImagesection.images[0]}`)" alt="" class="img-fluid">
                                    </div>
                                </div>
                                <div  data-aos="fade-up" class="col-4" >
                                    <div class="qr-code">
                                        <img :src="require(`../../assets/images/corporate-sustainability/${this.corporate.smallImagesection.images[1]}`)" alt="" class="img-fluid">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const corporate = [];
export default {
    
    name:"corporate",
   props:{
        corporate: Object
    }
}
</script>

<style lang="scss" scoped>
.section_one{
    @include Background('../../assets/images/corporate-sustainability/bg1.png');
    h2{
        @include Heading(right)
    }
    .images_section{
        .col-3{
            .small_image{
                max-width: 150px;
                margin-left: auto;
                margin-right: auto;
                margin-bottom: rem(25px);
            }
        }
        .col-6{
            .small_image{
                max-width: 150px;
            }
        }
    }    
    .icons_section{
        max-width: 500px;
        &.full-row{
            max-width:100%;
            .custom_border{
                max-width:900px;
                >.row{
                    text-align:center;
                    >div:last-child{
                        text-align:center;
                    }
                    .qr-code{
                        img{
                            max-width:95px;
                        }
                    }
                }
            }
            .icons{
                justify-content: center !important;
                p{
                    text-align:center;
                }
            }
        }
        &.icon_left{
            .icons{
                margin: unset;
                @include flex(center,flex-start);
                    margin-right: auto;
                    margin-bottom: rem(30px);
                    max-width: unset;
                .icon{
                    order: unset;
                    margin: unset;
                    margin-right: rem(30px);
                }
            }
            .title{
                text-align: left !important;
            }
        }
        .icons{
            @include flex(center,flex-end);
            margin-bottom: rem(30px);
            margin-left: auto;
            max-width: 420px;
            .icon{
                flex: 0 0 80px;
                order: 2;
                margin-left: rem(30px);
                @media screen and (max-width:551px){
                    flex: 0 0 50px;
                }
            }
            .title{
                flex:1;
                font-size: rem(30px);
                color: #fff;
                font-weight: bold;
                text-align: right;
            }
            @media screen and (max-width:767px){
                max-width:100%;
                justify-content:center !important;
                margin:rem(20px) auto;
                .title{
                    text-align:center;
                    flex:none;
                }
            }
        }
    }
    .fullWidth{
        max-width: unset;
        .custom_border {
            max-width: unset;
        }
    }
    .col-md-6.mx-auto.d-block.mb-md-0.mb-4{
        @media screen and (max-width:767px) {
            max-width: 100%;
            padding:0px 15px;
            margin-bottom:rem(30px) !important;
        }
    }
}
.brand-logos{
    margin-top:rem(50px);
    .icons{
        margin-bottom:rem(25px);
    }
    .custom_border{
        max-width:100%;
        >.row{
            padding-top:rem(40px);
            align-items: center;
            >div{
                margin-bottom:rem(20px);
            }
        }
    }
}

// arabic
    [lang="ar"] {
        .section_one{
            h2{
                @include Heading(left)
            }
               
            .icons_section{
                &.full-row {
                    .custom_border {
                        > .row {
                            > div:last-child{
                                text-align:center;
                            }
                        }
                    }
                }
                &.icon_left{
                    .icons{
                        
                            margin-left: auto;
                           margin-right: 0;
                        .icon{
                            
                            
                            margin-left: rem(30px);
                             margin-right: rem(0px);
                        }
                    }
                    .title{
                        text-align: right !important;
                    }
                }
                .icons{
                    
                    margin-right: auto;
                    margin-left: 0;
                    .icon{
                        
                        margin-right: rem(30px);
                        margin-left: 0;
                    }
                    .title{
                        
                        text-align: left;
                    }
                    @media screen and (max-width:767px){
                        
                        margin-left: auto;
                        margin-right: auto;
                        .title{
                            text-align:center;
                            
                        }
                    }
                }
            }
            
            
        }
    }
</style>